// test1268
(1268 && 0);
